import NavBarContainer from "../components/NavBarContainer";
import Loading from "../components/Loading";
import MapComponent from "../components/MapComponent";
import ReportList from "../components/ReportList";
import Profile from "../components/Profile";
import { React, useEffect, useState } from "react";
import axios from "axios";
import ReportView from "../components/ReportView";
import { useAuth } from "../hooks/AuthProvider";

function HomePage(props) {
  const [index, setIndex] = useState(0);
  const [report, setReport] = useState(null);

  const [markers, setMarkers] = useState(null);
  const [loading, setLoading] = useState(true);

  const profile = useAuth();

  function handleViewReport(report) {
    setReport(report);
    setIndex(3);
  }

  function handleDeleteReport(reportId) {
    setMarkers((list) => list.filter((item) => item._id !== reportId));
    axios.delete("api/reports/id/" + reportId).catch((err) => console.log(err));
  }

  function handleDelete() {
    const deleteData = window.confirm(
      "Are you sure you wish to delete all reports from database?"
    );
    if (deleteData) {
      axios.delete("api/reports/").then((response) => {
        if (response.status === 200) {
          window.alert("Reports deleted");
          setReport(null);
          setMarkers(null);
        }
      });
    }
  }

  useEffect(() => {
    if (index === 1 || index === 2) {
      axios
        .get("api/reports/quick")
        .then((response) => {
          var dataArray = [];
          const data = response.data;
          for (var i in data) {
            dataArray.push(data[i]);
          }
          console.log(dataArray);
          setMarkers(dataArray);
          setLoading(false);
          // console.log(markers);
        })
        // .then(() => {
        // setLoading(false);
        // console.log(markers);
        // })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [index]);

  return (
    <div>
      <NavBarContainer setIndex={setIndex} />
      <div className="App-body">
        {index === 0 ? <Profile /> : null}
        {index === 1 ? (
          <MapComponent
            isLoading={loading}
            onClick={handleViewReport}
            markers={markers}
          />
        ) : null}
        {index === 2 ? (
          <ReportList
            isLoading={loading}
            reports={markers}
            onView={handleViewReport}
            onDelete={handleDeleteReport}
            onDeleteAll={handleDelete}
          />
        ) : null}
        {index === 3 ? <ReportView report={report} /> : null}
        {index === 4 ? (
          <Loading containerDims="Loading" spinnerDims="loading-map" />
        ) : null}
      </div>
    </div>
  );
}

export default HomePage;
